import { PRICING } from "@/data/content";
import { Reveal, MaskLine, SectionLabel } from "./Reveal";

const HEAD = ["Offer", "Best for", "Inclusions", "Price (INR)"];

const StartTag = () => (
  <span className="inline-block mt-2 text-[10px] font-semibold tracking-[0.25em] uppercase text-[#B8874A]">Start here</span>
);

const DesktopTable = () => (
  <table className="hidden lg:table w-full text-left border-collapse" data-testid="pricing-table">
    <thead>
      <tr className="border-b border-[#221F1B]">
        {HEAD.map((h, i) => (
          <th key={h} className={`eyebrow !text-[#5C564E] py-5 font-semibold ${i === 3 ? "text-right" : ""}`}>{h}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {PRICING.map((p, i) => (
        <tr key={p.offer} className={`group border-b border-[#D8CFBC] transition-colors duration-500 hover:bg-[#EFE9DC] ${p.featured ? "bg-[#EFE9DC]" : ""}`} data-testid={`pricing-row-${i}`}>
          <td className="py-7 pr-6 pl-4 align-top w-[26%] relative">
            <span className={`absolute left-0 top-0 bottom-0 w-[2px] bg-[#B8874A] transition-opacity duration-500 ${p.featured ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`} />
            <span className="font-display text-xl text-[#221F1B] block">{p.offer}</span>
            {p.featured && <StartTag />}
          </td>
          <td className="py-7 pr-6 align-top w-[22%] text-[15px] text-[#4A453E]">{p.best}</td>
          <td className="py-7 pr-6 align-top text-[15px] leading-relaxed text-[#4A453E]">{p.inc}</td>
          <td className="py-7 pr-4 align-top text-right font-display text-xl text-[#16302B] whitespace-nowrap" data-testid={`pricing-price-${i}`}>{p.price}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

const MobileCards = () => (
  <div className="lg:hidden space-y-4" data-testid="pricing-cards-mobile">
    {PRICING.map((p, i) => (
      <Reveal key={p.offer} className={`border border-[#D8CFBC] p-6 ${p.featured ? "bg-[#EFE9DC] border-l-2 border-l-[#B8874A]" : "bg-[#F6F2E8]"}`} data-testid={`pricing-card-${i}`}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-2xl text-[#221F1B]">{p.offer}</h3>
            {p.featured && <StartTag />}
          </div>
          <p className="font-display text-lg text-[#16302B] text-right shrink-0">{p.price}</p>
        </div>
        <dl className="mt-5 space-y-3 text-[15px]">
          <div><dt className="eyebrow !text-[#5C564E] !text-[10px]">Best for</dt><dd className="mt-1 text-[#4A453E]">{p.best}</dd></div>
          <div><dt className="eyebrow !text-[#5C564E] !text-[10px]">Inclusions</dt><dd className="mt-1 text-[#4A453E] leading-relaxed">{p.inc}</dd></div>
        </dl>
      </Reveal>
    ))}
  </div>
);

export const Pricing = () => (
  <section id="pricing" className="relative bg-[#F6F2E8] py-24 sm:py-32 lg:py-40" data-testid="pricing-section">
    <div className="max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12">
      <Reveal><SectionLabel index="V.">Signature Offers</SectionLabel></Reveal>
      <h2 className="font-display mt-8 max-w-4xl text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.12] tracking-[-0.015em] text-[#221F1B]" data-testid="pricing-headline">
        <MaskLine inView>Ways to begin, from a single</MaskLine>
        <MaskLine inView delay={0.1} className="italic text-[#16302B]">call to a full program.</MaskLine>
      </h2>
      <Reveal className="mt-16">
        <DesktopTable />
      </Reveal>
      <div className="mt-12 lg:mt-0"><MobileCards /></div>
      <Reveal as="p" className="mt-10 max-w-3xl font-display italic text-lg sm:text-xl leading-relaxed text-[#16302B]" data-testid="pricing-note">
        Every engagement starts with a Discovery Session, so you never commit to a larger program before we've confirmed it's the right fit.
      </Reveal>
    </div>
  </section>
);
